<script lang="ts">
  import { Input } from '$lib/components/ui/input/index.js';

  interface Props {
    sendUpdate: CallableFunction;
    name: string | undefined;
    counter: number;
    enabled?: boolean;
  }

  let { sendUpdate, name = $bindable(), enabled = true, counter = 0 }: Props = $props();
</script>

<Input
  bind:value={name}
  disabled={!enabled}
  placeholder="Event name..."
  onblur={(e) => sendUpdate(counter)}
/>
